export const ItemTypes = {
    GROUP: 'g',
    FEATURE: 'f',
};

export const ModalModes = {
    ADD: "add",
    EDIT: "edit",
}